<template lang="html">
	<div
	id="performers"
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="section-container">
	<h1>Top Performers</h1>
	<div class="social-section">
		<img class="section-title" src="@/assets/img/social-dividers/tiktok.png">
		<div class="tiktok-gallery">
			<div class="phone-container">
			<img class='phone' src="@/assets/img/phone.png">
			<video controls class="phone-video">
					<source src="@/assets/img/tiktok/1.mp4" type="video/mp4">
			</video>
			</div>
			<div class="phone-container">
			<img class='phone' src="@/assets/img/phone.png">
			<video controls class="phone-video">
					<source src="@/assets/img/tiktok/2.mp4" type="video/mp4">
			</video>
			</div>
			<div class="phone-container">
			<img class='phone' src="@/assets/img/phone.png">
			<video controls class="phone-video">
					<source src="@/assets/img/tiktok/3.mp4" type="video/mp4">
			</video>
			</div>
		</div>
	</div>
	<div class="social-section instagram">
		<img class="section-title" src="@/assets/img/social-dividers/instagram.png">
		<div class="instagram-gallery">
			<img src="@/assets/img/instagram/IG_1.jpg">
			<img src="@/assets/img/instagram/IG_2.jpg">
			<img src="@/assets/img/instagram/IG_3.jpg">
			<video controls>
				<source src="@/assets/img/instagram/IG_4.mp4" type="video/mp4">
				Your browser does not support the video tag.
			</video>
			<video controls>
				<source src="@/assets/img/instagram/IG_5.mp4" type="video/mp4">
				Your browser does not support the video tag.
			</video>
			<img src="@/assets/img/instagram/IG_6.jpg">
			<video controls>
				<source src="@/assets/img/instagram/IG_7.mp4" type="video/mp4">
				Your browser does not support the video tag.
			</video>
			<video controls>
				<source src="@/assets/img/instagram/IG_8.mp4" type="video/mp4">
				Your browser does not support the video tag.
			</video>
			<img src="@/assets/img/instagram/IG_9.jpg">
		</div>
	</div>
	<div class="social-section">
		<img class="section-title" src="@/assets/img/social-dividers/twitter.png">
		<div class="twitter-gallery">
			<img src="@/assets/img/twitter/2.png">
			<img src="@/assets/img/twitter/1.png">
		</div>
	</div>
	</div>
</template>

<script>
import sal from "sal.js"; // No need to use in main.js file

export default {
	components: {
	},
	mounted() {
		sal();
	},
}
</script>

<style scoped lang="scss">
.section-container {
	width: 80%;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	h1 {
		font-family: $heading-font;
		color:white;
		text-decoration: underline;
		font-size:60px;
		text-transform: uppercase;
		font-weight: 900;
		margin-top:50px;
	}
	.social-section {
		display: flex;
		flex-direction: column;
		align-items: center;
		.section-title {
			max-width: 300px;
			padding: 25px;
		}
		.tiktok-gallery {
			display: flex;
			flex-direction: column;
			flex-flow: wrap;
			align-items: center;
			justify-content: center;
		}
		.twitter-gallery {
			display: flex;
			flex-direction: column;
			flex-flow: wrap;
			align-items: center;
			justify-content: center;
			img {
				width: 80%;
			}
		}
		.instagram-gallery {
			img {
				width:100%;
				max-width: 250px;
				margin:5px;
				box-shadow: 1px 1px 10px black;
			}
			video {
				width: 100%;
				max-width: 250px;
				margin:5px;
				box-shadow: 1px 1px 10px black;
			}
		}
	}
}

.phone-container {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding:20px;
	margin-top:20px;
	.phone {
		width: 575px;
		height: 600px;
		position:absolute;
	}
	.phone-video {
		width: 280px;
		border-radius: 30px;
	}
}
		
</style>